<template>
  <v-card class="map">
    <div class="map_header">
      <span class="map_header-title">
        <div class="map_select-map">
          <v-menu
            v-model="camSelectOpen"
            offset-y
            content-class="map_select-content"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="text" text v-bind="attrs" v-on="on">
                {{ currentMap.label }}
                <span
                  class="icon icon-chevron-down map_chevron"
                  :class="{ 'map_chevron-open': camSelectOpen }"
                />
              </v-btn>
            </template>
            <v-list style="padding: 0">
              <v-list-item
                v-for="(item, index) in mapItems"
                :key="index"
                link
                @click="handleSelectMap(item)"
              >
                <v-list-item-title
                  :class="{ ['active-select-map']: item.key === selectedMap }"
                >
                  <span
                    v-if="item.key === selectedMap"
                    class="icon icon-check map_select-icon"
                  />
                  <span v-else class="map_select-icon-gap" />
                  {{ item.label }}</v-list-item-title
                >
              </v-list-item>
            </v-list>
          </v-menu>
          <!-- <v-select
            flat
            :items="mapItems"
            :menu-props="{ top: true, offsetY: true }"
            item-text="label"
            item-value="key"
            v-on:change="handleSelectMap"
            v-model="selectedMap"
          ></v-select> -->
        </div>
      </span>
      <v-btn icon class="map_header-action">
        <span class="icon icon-3dots" />
      </v-btn>
    </div>
    <div class="map_content">
      <img :src="currentMap.src" class="map_img" />
      <map-cam
        v-for="(cam, icam) in currentMap.cams"
        :key="icam"
        :cam="cam"
        @onClick="handleCamClick"
      />
    </div>
  </v-card>
</template>

<script>
import MapCam from './MapCam.vue';
export default {
  name: 'MapB',
  components: { MapCam },
  data: function () {
    return {
      camSelectOpen: false,
      mapItems: [
        {
          key: 1,
          label: '三鷹駅の店舗',
          src: require('../../assets/img/map/map2.png'),
          cams: [
            {
              key: 1,
              id: 1,
              left: 11,
              bottom: 0,
              right: 0,
              top: 9,
              rotate: 132,
              active: false,
              tooltip: '三鷹駅の店舗​<br/>レジカウンター​',
            },
          ],
        },
        {
          key: 2,
          label: 'オーナー自宅',
          src: require('../../assets/img/map/map3.png'),
          cams: [
            {
              key: 2,
              id: 1,
              left: 24,
              bottom: 42,
              right: 0,
              top: 186,
              rotate: 130,
              active: false,
              tooltip: 'オーナー自宅 玄関',
            },
          ],
        },
      ],
      selectedMap: 1,
    };
  },
  computed: {
    currentMap() {
      return this.mapItems.filter((map) => map.key === this.selectedMap)[0];
    },
  },
  methods: {
    handleSelectMap(map) {
      this.selectedMap = map.key;
    },
    handleCamClick({ cam }) {
      cam.active = !cam.active;
    },
  },
};
</script>

<style lang="scss">
.map {
  width: 395px;
  height: 100%;
  &_chevron {
    margin-left: 4px;
    &-open {
      transform: rotate(180deg);
    }
  }
  &_img {
    max-width: 100%;
  }
  &_select {
    &-icon {
      color: #0075c2;
      font-size: 18px;
      font-weight: 100;
      margin-right: 6px;
      &-gap {
        width: 20px;
        display: inline-block;
      }
    }
    &-map {
      .v-btn {
        font-size: 14px !important;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.29;
        letter-spacing: normal;
        text-align: left;
        color: #4b4b4b !important;
      }
    }
    &-content {
      width: 250px;
      border-radius: 10px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.12);
      background-color: #fff;
      .v-list-item__title {
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.43;
        letter-spacing: normal;
        text-align: left;
        color: #666;
      }
      .active-select-map {
        color: #0075c2;
      }
    }
  }
  &_link {
    padding: 10px;
    margin-left: 20px;
    font-size: 13px;
    font-weight: normal;
    line-height: 18px;
    &-root {
      line-height: 1px;
    }
    .header & {
      color: #666;
    }
    &-active {
      text-decoration: none;
      background-color: #eeeeee;
      border-radius: 5px;
    }
    &.router-link-active {
      font-weight: 600;
      cursor: text;
      color: var(--primary-color);
      transform: scale(1.15);
      &:hover {
        text-decoration: none;
      }
    }
  }
  &_header {
    margin-bottom: 35px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    &-title {
      color: #4b4b4b;
      font-size: 14px;
    }
    &-action {
      .icon {
        color: #989898;
        font-size: 14px;
      }
    }
  }
  &_content {
    position: relative;
    padding: 0px 15px;
    &-camera {
      position: absolute;
    }
  }
}
</style>
